import dayjs from "dayjs";
import { getDateDiffFromToday } from "./utils";
function calculateTimeLeft(inputTime) {
  if (!inputTime) {
    return "ERROR";
  }
  try {
    const inputDate = new Date(inputTime);
    const currentDate = new Date();

    if (inputDate <= currentDate) {
      return "TIME_EXCEED";
    }

    const timeDiff = inputDate - currentDate;

    // Convert the difference to hours and minutes
    const totalMinutes = Math.floor(timeDiff / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Format hours and minutes to always have 2 digits
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");

    return {
      hours: formattedHours,
      minutes: formattedMinutes
    };
  } catch (error) {
    return "ERROR";
  }
}

function getBoostDetails(boostDetails = {}) {
  const {
    status,
    expiryDate,
    startEligibleDate,
    total_mini_boost_limit,
    current_mini_boost_count
  } = boostDetails;
  let dayDiff = null;
  try {
    dayDiff = getDateDiffFromToday(expiryDate);
  } catch (err) {}
  const initialState =
    status === "ELIGIBLE" || status === "INELIGIBLE_JOB_EXPIRING";

  const inProgress = status === "INPROGRESS";
  const completed = status === "COMPLETED";
  const jobExpiringInEligible = status === "INELIGIBLE_JOB_EXPIRING";
  const notEligible = status === "INELIGIBLE";
  const completedAndDateNotExpired = dayDiff <= 5 && status == "COMPLETED";
  const boostYetToStart = status === "INELIGIBLE_RECENT_PREMIUM_JOB";
  const show =
    initialState || inProgress || completedAndDateNotExpired || boostYetToStart;
  const availableBoost =
    Number(total_mini_boost_limit) - Number(current_mini_boost_count);
  const boostAgain = current_mini_boost_count > 0;
  const boostLimitReached = current_mini_boost_count === total_mini_boost_limit;
  const timeLeftForExpiry = calculateTimeLeft(expiryDate);

  return {
    initialState,
    inProgress,
    completed,
    jobExpiringInEligible,
    notEligible,
    show,
    expiryDateRender: expiryDate
      ? dayjs(expiryDate).format("hh:mma, MMM D, YYYY")
      : null,
    startsIn: calculateTimeLeft(startEligibleDate),
    boostYetToStart,
    dayDiff,
    availableBoost,
    boostAgain,
    boostLimitReached,
    timeLeftForExpiry
  };
}

export { getBoostDetails };
